import { render, staticRenderFns } from "./ComprehensivePayrollReport.vue?vue&type=template&id=10ae538b"
import script from "./ComprehensivePayrollReport.vue?vue&type=script&lang=js"
export * from "./ComprehensivePayrollReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports